const reducer = (state = {}, action) =>{
    switch(action.type){
        case "setTransactionDetails": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  